<div mat-dialog-title>Liste des pages associées</div>
<div class="p8-bdc_pages-list__pages-container" fxLayout="row wrap">
  <mat-list *ngIf="data && data.length > 0">
    <mat-list-item *ngFor="let page of data">
      <mat-icon matListIcon>label</mat-icon>
      <p matLine>{{page.title}}</p>
    </mat-list-item>
  </mat-list>
</div>
